<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.el-table::before {
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue